import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ReportInfoModal({showModal, handleCloseModal,selectedReport}) {


  

  return (
      <Modal show={showModal} onHide={handleCloseModal} size="lg" scrollable>
        <Modal.Header className='bg-dark'>
          <Modal.Title className='fs-5 text-white mb-0'>تفاصيل العريضة</Modal.Title>
          <Button variant="light" className="mb-0" size="sm" onClick={handleCloseModal} aria-label="Close"><i class="bi bi-x-lg"></i></Button>
        </Modal.Header>
        <Modal.Body>
        <div class="modal-body p-4">

        <div>
				<p class="mb-3 text-dark">{selectedReport?.content}</p>
        </div>
        {selectedReport?.attachments.length ? <div className='mt-4'>
				<h6>المرفقات:</h6>
        <ul>
        {selectedReport?.attachments.map(at =>(
          <li>
          <a target='_blank' href={at.attachment} key={at.id}>{at.title}</a>
          </li>
        ))}
        </ul>
        </div> :null}


				


			</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className='my-0' variant="danger-soft" onClick={handleCloseModal}>
          إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
  );
}
export default ReportInfoModal